import React, { useCallback } from "react";
import "./style.less";
import { Icon } from "semantic-ui-react";
import { setMapZoom } from "../../../../redux/geofence/actions";
import { useDispatch, useSelector } from "react-redux";

function ZoomControls() {
  const dispatch = useDispatch();
  const zoomLevel = useSelector(({ geofence }) => geofence.mapZoom);
  const zoomIn = useCallback(() => {
    dispatch(setMapZoom(zoomLevel + 1));
  }, [zoomLevel, dispatch]);

  const zoomOut = useCallback(() => {
    dispatch(setMapZoom(zoomLevel - 1));
  }, [zoomLevel, dispatch]);

  return (
    <div className="ZoomControls">
      <div onClick={zoomIn} className="zoomInContainer">
        <div className="zoomIn">
          <Icon name="plus" />
        </div>
      </div>
      <hr />
      <div onClick={zoomOut} className="zoomOutContainer">
        <div className="zoomOut">
          <Icon name="minus" />
        </div>
      </div>
    </div>
  );
}

ZoomControls.defaultProps = {};

ZoomControls.propTypes = {};

export default ZoomControls;
